export const CONTROL_PANEL_COMMON_INFORMATION = '/control-panel/common-information';
export const CONTROL_PANEL_KEYS = '/control-panel/keys';
export const CONTROL_PANEL_COMMON_SERVICES = '/control-panel/services';
export const CONTROL_PANEL_ACCOUNTS = '/control-panel/accounts';